// What `GET /api/context/player/:id` answers.
//
// The dossier itself belongs to the Info Manager (ICD-S08) and is defined
// there; this is the envelope around it — which view was asked for, and the
// dossier that view produced. Named here because the wire shape is the API's
// to declare, and because `contracts:schema` generates from the API package.
//
// THE RAW DOSSIER IS THE CONTRACT, for now. `playerDetailFromDossier` and
// `lineupRowFromDetail` in this same package hold the hard reading rules —
// subject-ref matching, bye detection, the `CANNOT_SCORE` flag CLAUDE.md
// requires the site to state — and nothing under `functions/` calls them, so
// every client would port that reader (audit 3.8). That is an open decision,
// not something this phase settles: serving `PlayerDetailView` beside the
// dossier is additive and can land whenever it is decided.

import { z } from 'zod';
import { Dossier } from '@fsp/info';

export const PlayerContextView = z.object({
  /** `dossier`, `row`, … — the named bundle of sections that was asked for. */
  view: z.string(),
  dossier: Dossier,
});
export type PlayerContextView = z.infer<typeof PlayerContextView>;
